"use strict";

var Event = require("../generated/Event");

var _require = require("../generated/utils"),
    tryImplForWrapper = _require.tryImplForWrapper;

function createAnEvent(e, globalObject) {
  var eventInterface = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Event;
  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return eventInterface.createImpl(globalObject, [e, attributes], {
    isTrusted: attributes.isTrusted !== false
  });
}

function fireAnEvent(e, target, eventInterface, attributes, legacyTargetOverrideFlag) {
  var event = createAnEvent(e, target._globalObject, eventInterface, attributes); // tryImplForWrapper() is currently required due to use in Window.js

  return tryImplForWrapper(target)._dispatch(event, legacyTargetOverrideFlag);
}

module.exports = {
  createAnEvent: createAnEvent,
  fireAnEvent: fireAnEvent
};